import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import styles from "./LanguageSelect.scss";

const cx = classnames.bind(styles);

const DropdownOptionContent = ({ option }) =>
  !!option && (
    <>
      <svg width={14} height={9} className={cx("flag")}>
        <use href={`#${option.icon}`} />
      </svg>
      <span className={cx("option-label")}>{option.label}</span>
    </>
  );

DropdownOptionContent.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.string,
  }),
};

export default DropdownOptionContent;
